import { c as _c } from "react-compiler-runtime";
import { registerQuery, useQuery } from 'data-fetching-client';
import userInfoHubHttp from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
const realtimeCommentingGate = gate('MarketingPlatform::RealtimeCommenting');
const buildGatesForUser = gates => {
  const gatesForUser = {
    realtimeCommenting: false
  };
  let gatesToCheck = Object.keys(gatesForUser).length;
  for (const gateToCheck of gates) {
    if (gateToCheck === realtimeCommentingGate) {
      gatesForUser.realtimeCommenting = true;
      gatesToCheck = gatesToCheck - 1;
    }
    if (gatesToCheck === 0) {
      break;
    }
  }
  return gatesForUser;
};
const SCOPES_FOR_SUPPORTED_HUBS = {
  MARKETING_HUB: 'commenting-access-marketing-hub',
  SERVICE_HUB: 'commenting-access-service-hub',
  CMS_HUB: 'commenting-access-cms-hub',
  OPS_HUB: 'commenting-access-ops-hub',
  SALES_HUB: 'commenting-access-sales-hub'
};
const buildScopesForUser = scopes => {
  const scopesForUser = {
    'ads-read': false,
    'blog-write': false,
    'calendar-access': false,
    'campaigns-access': false,
    'campaigns-write': false,
    'commenting-access-cms-hub': false,
    'commenting-access-marketing-hub': false,
    'commenting-access-ops-hub': false,
    'commenting-access-sales-hub': false,
    'commenting-access-service-hub': false,
    'email-write': false,
    'landingpages-write': false,
    'marketing-tasks-write': false,
    'pages-write': false,
    'teams-advanced-modeling-access': false
  };
  let scopesToCheck = Object.keys(scopesForUser).length;
  const isScopeCollaborationSidebarScope = scope => {
    return scope in scopesForUser;
  };
  for (const scope of scopes) {
    if (isScopeCollaborationSidebarScope(scope)) {
      scopesForUser[scope] = true;
      scopesToCheck = scopesToCheck - 1;
    }
    if (scopesToCheck === 0) {
      break;
    }
  }
  return scopesForUser;
};
const USER_INFO_QUERY = registerQuery({
  args: [],
  fieldName: 'collaborationSidebarUserInfo',
  fetcher: async () => {
    const userInfoResponse = await userInfoHubHttp();
    return Object.assign({}, userInfoResponse, {
      gatesForUser: buildGatesForUser(userInfoResponse.gates || []),
      scopesForUser: buildScopesForUser(userInfoResponse.user.scopes)
    });
  }
});
export const useUserInfo = () => {
  "use memo";

  var _data$collaborationSi, _data$collaborationSi4;
  const $ = _c(13);
  const {
    data,
    loading: userInfoLoading,
    error: userInfoError
  } = useQuery(USER_INFO_QUERY);
  let t0;
  if ($[0] !== (data === null || data === void 0 || (_data$collaborationSi = data.collaborationSidebarUserInfo) === null || _data$collaborationSi === void 0 ? void 0 : _data$collaborationSi.gatesForUser)) {
    var _data$collaborationSi3;
    t0 = gateToCheck => {
      var _data$collaborationSi2;
      return !!(data !== null && data !== void 0 && (_data$collaborationSi2 = data.collaborationSidebarUserInfo) !== null && _data$collaborationSi2 !== void 0 && _data$collaborationSi2.gatesForUser[gateToCheck]);
    };
    $[0] = data === null || data === void 0 || (_data$collaborationSi3 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi3 === void 0 ? void 0 : _data$collaborationSi3.gatesForUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasGate = t0;
  let t1;
  if ($[2] !== (data === null || data === void 0 || (_data$collaborationSi4 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi4 === void 0 ? void 0 : _data$collaborationSi4.scopesForUser)) {
    var _data$collaborationSi6;
    t1 = scopeToCheck => {
      var _data$collaborationSi5;
      return !!(data !== null && data !== void 0 && (_data$collaborationSi5 = data.collaborationSidebarUserInfo) !== null && _data$collaborationSi5 !== void 0 && _data$collaborationSi5.scopesForUser[scopeToCheck]);
    };
    $[2] = data === null || data === void 0 || (_data$collaborationSi6 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi6 === void 0 ? void 0 : _data$collaborationSi6.scopesForUser;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasScope = t1;
  let t2;
  if ($[4] !== hasScope) {
    t2 = hub => hasScope(SCOPES_FOR_SUPPORTED_HUBS[hub]);
    $[4] = hasScope;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const hasScopeForHub = t2;
  const t3 = data === null || data === void 0 ? void 0 : data.collaborationSidebarUserInfo;
  let t4;
  if ($[6] !== hasGate || $[7] !== hasScope || $[8] !== hasScopeForHub || $[9] !== t3 || $[10] !== userInfoError || $[11] !== userInfoLoading) {
    t4 = {
      userInfo: t3,
      userInfoLoading,
      userInfoError,
      hasGate,
      hasScope,
      hasScopeForHub
    };
    $[6] = hasGate;
    $[7] = hasScope;
    $[8] = hasScopeForHub;
    $[9] = t3;
    $[10] = userInfoError;
    $[11] = userInfoLoading;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};